<script>
export default {
  name: 'InputError',
  props: {
    name: {
      type: String,
      default: null,
    },
    errorMessage: {
      type: String,
      default: null,
    },
  },
};
</script>

<template>
  <p
    v-if="errorMessage"
    :id="`${name}-help`"
    class="p-error"
    :class="$style.error"
    :data-cy="`error-${name}`"
  >
    {{ errorMessage }}
  </p>
</template>

<style module>
.error {
  margin-top: 0.25rem;
  margin-bottom: 0;
  font-family: Manrope, system-Helvetica, 'Segoe UI', sans-serif;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 300;
  font-style: normal;
}
</style>
